import { jsx as _jsx } from "react/jsx-runtime";
import { Circle as Component, } from '@alfalab/core-components/icon-view/circle';
import { Skeleton } from '@alfalab/core-components/skeleton';
import { useImageLoadingState } from '@alfalab/hooks';
import { Child } from '../child';
import styles from './index.module.css';
/**
 * Оборачивает графику в круг
 *
 * [Макет](https://www.figma.com/design/OiFlIdSpmFYZ5zsFGWA3TD/Web-%3A%3A-Alfa-Online-Composites?node-id=102575-522685)
 *
 */
export const Circle = ({ children, imageUrl: imageUrlProp, backgroundColor: backgroundColorProp, text, size = 48, border = true, colorText, allowShowLoader = true, ...restProps }) => {
    // Для src намеренно используется || ""
    // тк значение по умолчанию не применяется к src когда в нем null
    const imageLoadingState = useImageLoadingState({ src: imageUrlProp || '' });
    const imageFailed = imageLoadingState === 'error';
    const backgroundColor = imageFailed && !text ? undefined : backgroundColorProp;
    if (allowShowLoader && imageUrlProp && imageLoadingState === 'loading') {
        return (_jsx(Skeleton, { visible: true, className: styles.skeleton, dataTestId: 'avatar-skeleton', children: _jsx(Component, { ...restProps, border: border, size: size }) }));
    }
    const imageUrl = imageFailed || !imageUrlProp ? undefined : imageUrlProp;
    return (_jsx(Component, { ...restProps, border: border, size: size, imageUrl: imageUrl, backgroundColor: backgroundColor, children: _jsx(Child, { hasImage: Boolean(imageUrl), imageLoadingFailed: imageFailed, text: text, colorText: colorText, size: size, children: children }) }));
};
